import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import faqData from "../data/faqData.json";

const FaqPage = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [sortedFaqs, setSortedFaqs] = useState([]);

  useEffect(() => {
    // Sort FAQs based on frequency in descending order
    const sorted = [...faqData].sort((a, b) => b.frequency - a.frequency);
    setSortedFaqs(sorted);
  }, []);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h2 className="text-2xl text-center font-bold text-gray-800 mb-8">Frequently Asked Questions</h2>
      <div className="space-y-2 md:space-y-4">
        {sortedFaqs.map((faq, index) => (
          <div key={index} className="border rounded-xl px-4 py-2">
            <button
              className="flex justify-between items-center w-full text-left font-medium text-base md:text-lg"
              onClick={() => toggle(index)}
            >
              {faq.question}
              {openIndex === index ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </button>
            {openIndex === index && (
              <p className="mt-3 text-gray-600 text-sm">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqPage;
